module.exports = __webpack_public_path__ + "static/img/banner.7126b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/基因编辑/banner.png
// module id = lB1p
// module chunks = 16